import { createContext, useContext, useState, useEffect } from "react";

const StoreContext = createContext();

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};

export const StoreProvider = ({
  children,
  stores = [],
  storeOrders = {},
  storeAnalytics = {},
  storeMenuItems = {},
  storeChannels = {},
}) => {
  const [selectedStoreId, setSelectedStoreId] = useState(
    stores[0]?.id || "store-1",
  );
  const [allStores] = useState(stores);

  const selectedStore = allStores.find((store) => store.id === selectedStoreId);

  const getCurrentStoreData = (dataType) => {
    switch (dataType) {
      case "orders":
        return storeOrders[selectedStoreId] || [];
      case "analytics":
        return storeAnalytics[selectedStoreId] || {};
      case "menuItems":
        return storeMenuItems[selectedStoreId] || [];
      case "channels":
        return storeChannels[selectedStoreId] || [];
      default:
        return null;
    }
  };

  const switchStore = (storeId) => {
    if (allStores.some((store) => store.id === storeId)) {
      setSelectedStoreId(storeId);
      localStorage.setItem("selectedStoreId", storeId);
    }
  };

  useEffect(() => {
    const savedStoreId = localStorage.getItem("selectedStoreId");
    if (savedStoreId && allStores.some((store) => store.id === savedStoreId)) {
      setSelectedStoreId(savedStoreId);
    }
  }, [allStores]);

  const value = {
    selectedStore,
    selectedStoreId,
    allStores,
    switchStore,
    getCurrentStoreData,
    orders: getCurrentStoreData("orders"),
    analytics: getCurrentStoreData("analytics"),
    menuItems: getCurrentStoreData("menuItems"),
    channels: getCurrentStoreData("channels"),
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
